<div class="filterContainer">
    <div class="userFilterContainer">

        <div *ngIf="componentName == ''" class="filterInputContainer" style="margin-left:15px;">
            <div>CSE Status</div>
            <input class="filterInput" type="text" [(ngModel)]="cse_name" (keyup)="filterEnterClick($event)"
                placeholder="Filter By CSE Status" />
        </div>

        <div *ngIf="componentName == 'facilityListing'" class="filterInputContainer">
            <div>State</div>
            <select class="stateInput" [(ngModel)]="state_name">
                <option value="">Please Select</option>
                <option *ngFor="let state of stateList" [value]="state.state_name">
                    {{state.state_name}}
                </option>
            </select>
        </div>

        <div *ngIf="componentName == 'facilityListing'" class="filterInputContainer" style="margin-left:15px;">
            <div>Payment Status</div>
            <select class="stateInput" [(ngModel)]="payment_status" (change)="paymentStatusChange($event.target.value)">
                <option value="">Please Select</option>
                <option *ngFor="let paymentStatus of paymentStatusList" [value]="paymentStatus">
                    {{paymentStatus}}
                </option>
            </select>
        </div>

        <div *ngIf="" class="filterInputContainer">
            <div>CSE Name</div>
            <input class="filterInput" type="text" [(ngModel)]="facility_name" (keyup)="filterEnterClick($event)"
                placeholder="Filter By CSE Name" />
        </div>

        <div *ngIf="componentName == 'cseListing'" class="filterInputContainer">
            <div>Name of Lead Doctor</div>
            <input class="filterInput" type="text" [(ngModel)]="lead_dr_name" (keyup)="filterEnterClick($event)"
                placeholder="Filter By Lead Doctor" />
        </div>
    </div>

    <div class="filterButtonContainer">
        <button type="button" (click)="searchFilterClick()">SEARCH</button>
        <button type="button" (click)="resetFilterClick()" style="margin-left: 15px;">RESET</button>
    </div>
</div>